import styled, { css } from 'styled-components'

const SceneWrapper = ({ padding, children }) => {
  return <Wrapper padding={padding}>{children}</Wrapper>
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${({ padding }) =>
    padding &&
    css`
      padding: ${padding};
    `}
`

export default SceneWrapper
